export class FilterProperties {
  key: string | null;
  where: string | null;
  value: string | number | null;

  constructor(key: string, where: string, value: string | number | null) {
    this.key = key;
    this.where = where;
    this.value = value;
  }
}

export class SearchVehiclesQueryContext {
  filters: FilterProperties[] = [];
  limit = 20;
  offset = 0;
  sortBy: string[] = [];
  sortDir: string[] = [];

  constructor(
    filters: FilterProperties[],
    limit: number,
    offset: number,
    sortBy: string[],
    sortDir: string[]
  ) {
    this.filters = filters;
    this.limit = limit;
    this.offset = offset;
    this.sortBy = sortBy;
    this.sortDir = sortDir;
  }
}
